import type { SalesOrderMetricId } from '@/types/workflowSummary'

export const SALES_ORDER_METRIC_COPY: Record<
  SalesOrderMetricId,
  { label: string; description: string }
> = {
  awaiting_validation: {
    label: 'Awaiting validation',
    description: 'Customer orders that need validation',
  },
  done: {
    label: 'Done',
    description: 'Customer orders that need no further work',
  },
}
